import a from "react";
import { global as _ } from "./color/color-tokens.esm.js";
import "./color/color-config.esm.js";
const o = "_productImage_h7sjx_1", g = "_productImage__img_h7sjx_7", l = "_productImage__fallback_h7sjx_19", r = "_productImage__fallbackImg_h7sjx_40", e = {
  productImage: o,
  productImage__img: g,
  productImage__fallback: l,
  productImage__fallbackImg: r
}, s = `data:image/svg+xml, ${encodeURIComponent(
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1 1">
	<path d="M0 0h1v1H0" fill="${_.grey400}"/>
	</svg>`
)}`;
function p({
  alt: t,
  isAltReal: m = !1,
  ...c
}) {
  return /* @__PURE__ */ a.createElement("span", { ...c, className: e.productImage__fallback }, /* @__PURE__ */ a.createElement(
    "img",
    {
      src: s,
      className: e.productImage__fallbackImg,
      alt: t,
      "aria-hidden": m ? void 0 : "true"
    }
  ));
}
p.displayName = "DefaultImage";
export {
  p as D,
  e as s
};
